
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ExternalLink } from 'lucide-react';

const AuthorityReferences = () => {
  const authorityReferences = [
    {
      title: "National Roofing Contractors Association (NRCA)",
      url: "https://www.nrca.net",
      description: "Industry standards and best practices"
    },
    {
      title: "GAF Master Elite® Certification Program",
      url: "https://www.gaf.com/en-us/contractors/master-elite",
      description: "Factory-authorized training and warranties"
    },
    {
      title: "ENERGY STAR® Roof Products",
      url: "https://www.energystar.gov/products/building_products/roof_products",
      description: "Energy efficiency standards and rebates"
    },
    {
      title: "FORTIFIED Roof™ Program",
      url: "https://fortifiedhome.org",
      description: "Hurricane and severe weather resistance standards"
    },
    {
      title: "Cool Roof Rating Council (CRRC)",
      url: "https://coolroofs.org",
      description: "Reflective roofing performance data"
    },
    {
      title: "International Code Council (ICC)",
      url: "https://www.iccsafe.org",
      description: "Building codes and safety standards"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">🏆 Industry Authority & Certifications</h2>
            <p className="text-gray-600">Our work is backed by industry-leading organizations and standards</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {authorityReferences.map((ref, index) => (
              <Card key={index} className="hover:shadow-lg transition-shadow">
                <CardContent className="p-4">
                  <div className="flex items-start justify-between mb-2">
                    <h4 className="font-semibold text-sm leading-tight">{ref.title}</h4>
                    <ExternalLink className="h-4 w-4 text-gray-400 flex-shrink-0 ml-2" />
                  </div>
                  <p className="text-xs text-gray-600 mb-3">{ref.description}</p>
                  <a 
                    href={ref.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-xs text-primary hover:underline break-all"
                  >
                    {ref.url}
                  </a>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuthorityReferences;
